export default __webpack_public_path__ + "static/media/item_5.95c10b08.webp";